import axios from 'axios'
import HTTP from './http'

export default {
    getApiContent: () => axios.get(HTTP.INFO_MSG),
    updateContent: payload => axios.patch(HTTP.INFO_MSG, { payload }),
    deleteContent: payload => axios.delete(HTTP.INFO_MSG, { params: payload }),
    addContent: payload => axios.post(HTTP.INFO_MSG, { payload }),
    getTypes: () => axios.get(HTTP.INFO_MSG_TYPES),
    fakeSms: payload => axios.post(HTTP.SMS_ADMIN, { payload }),
    sendFinanceSms: payload => axios.post(HTTP.SMS_FINANCE, { payload }),
    sendMailCRMError: payload => axios.post(HTTP.MAIL_ADMIN, { payload })
}
